/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowTableRowsListResponse {
    getFixupPrototypeFunction() { return ServiceNowTableRowsListResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowTableRowsListResponse>): ServiceNowTableRowsListResponse {
        let obj = Object.assign(new ServiceNowTableRowsListResponse(), model);
        ServiceNowTableRowsListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowTableRowsListResponse>): ServiceNowTableRowsListResponse {
        if (!model) return null;
        return ServiceNowTableRowsListResponse.newInstance(<ServiceNowTableRowsListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowTableRowsListResponse) {
        if (!obj) return;

        models.ServiceNowTableRowsListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowTableRowsListResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowTableRowsListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.ServiceNowTableRow.fixupPrototype(val);
            }
        }
    }

    /**
     * Table rows.
     */
    results: Array<models.ServiceNowTableRow>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
